import type { SignageOnlineStatus } from 'noddi-async';
import type { BadgeVariant } from 'noddi-ui-web';

export const ONLINE_STATUS_LABEL: Record<SignageOnlineStatus, string> = {
  online: 'Online',
  degraded: 'Degraded',
  offline: 'Offline',
  never_seen: 'Never seen'
};

export const ONLINE_STATUS_VARIANT: Record<SignageOnlineStatus, BadgeVariant> = {
  online: 'success',
  degraded: 'warning',
  offline: 'destructive',
  never_seen: 'info'
};

/** Short explanations for tooltips and the fleet legend. */
export const ONLINE_STATUS_DESCRIPTION: Record<SignageOnlineStatus, string> = {
  online: 'Device checked in recently (browser player and/or OS agent).',
  degraded:
    'Device is partially reachable — for example player or OS telemetry is stale while the other still reports.',
  offline: 'Device has checked in before, but is currently unreachable.',
  never_seen:
    'Device was paired or enrolled during flash, but has never booted or checked in. Power it on and connect it to the network to complete setup.'
};

export const SIGNAGE_ONLINE_STATUSES: SignageOnlineStatus[] = ['online', 'degraded', 'offline', 'never_seen'];
